"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sources = exports.sourceLayer = exports.presenterBanner = exports.extraCameraSources = void 0;
var _constants = require("../constants/");
var _Placeholders = require("@studio/constants/Placeholders");
/**
 * @param {string} templateType
 */
var presenterBanner = exports.presenterBanner = {
  _id: '123456',
  layer: {
    isContent: false,
    _id: '123456',
    style: {
      bottom: '0%',
      width: '100%',
      position: 'absolute',
      bannerStyles: {
        top: 0
      },
      bannerAnimation: {
        animate: {}
      }
    },
    title: 'Basic banner'
  },
  source: {
    hidden: false,
    _id: '123456',
    deleted: false,
    type: 'banner',
    title: 'Auto titles',
    createdOn: 1632336106233,
    modifiedOn: 1636362032715,
    value: {
      templateVars: {
        LINE_1: 'Presenter name',
        LINE_2: 'Presenter title',
        LINE_3: '123456',
        ACCENT_COLOR: '#FFEA7F'
      },
      autoLeave: false,
      transitionStyle: '',
      templateType: 'presenterBanner',
      markup: '<section\nstyle="\ndisplay: flex;\nflex-direction: column;\nalign-items: flex-start;\npadding: 2px 12px;\nwidth: auto;\nbackground: #FFFFFF;\nbox-shadow: inset 4px 0px 0px #DE2F1B;\nborder-radius: 0px 8px 8px 0px;\n"\n>\n<h1\nstyle="\nheight: 16px;\nleft: 12px;\ntop: 4px;\nfont-style: normal;\nfont-weight: bold;\nfont-size: 16px;\nline-height: 16px;\ndisplay: flex;\nalign-items: center;\nletter-spacing: -0.01em;\ncolor: #33373D;\n"\n>\nPresenter name\n</h1>\n<h2\nstyle="\nheight: 12px;\nleft: 12px;\ntop: 24px;\nfont-style: normal;\nfont-weight: 500;\nfont-size: 12px;\nline-height: 12px;\ndisplay: flex;\nalign-items: center;\nletter-spacing: -0.01em;\ncolor: #6E7582;\n"\n>\nPresenter title\n</h2>\n</section>'
    }
  }
};
var sources = exports.sources = [{
  _id: '2',
  value: '',
  hidden: false,
  type: _constants.VIDEO_FILE,
  title: 'Video file'
}, {
  _id: '3',
  hidden: false,
  type: _constants.IMAGE_FILE,
  title: 'Image file',
  value: (0, _Placeholders.getPlaceholderUrl)('500x300')
}, {
  _id: '4',
  value: '',
  hidden: false,
  type: _constants.CAMERA_PRESENTER,
  title: 'Presenter Camera'
}, {
  _id: '5',
  value: '',
  hidden: false,
  type: _constants.SCREEN_PRESENTER,
  title: 'Presenter Screenshare'
}, {
  _id: '6',
  hidden: false,
  type: _constants.PDF_FILE,
  title: 'Pdf file',
  value: {
    activePage: 3,
    url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
  }
}];
var extraCameraSources = exports.extraCameraSources = [{
  _id: '4',
  value: '',
  hidden: false,
  type: _constants.CAMERA_PRESENTER,
  title: 'Extra Presenter Camera 1'
}, {
  _id: '4',
  value: '',
  hidden: false,
  type: _constants.CAMERA_PRESENTER,
  title: 'Extra Presenter Camera 2'
}, {
  _id: '4',
  value: '',
  hidden: false,
  type: _constants.CAMERA_PRESENTER,
  title: 'Extra Presenter Camera 3'
}, {
  _id: '4',
  value: '',
  hidden: false,
  type: _constants.CAMERA_PRESENTER,
  title: 'Extra Presenter Camera 4'
}];
var sourceLayer = exports.sourceLayer = {
  _id: '123456',
  source: {
    order: 1,
    _id: '123456',
    hidden: false,
    deleted: false,
    featured: false,
    value: 'Unassigned',
    title: 'Presenter 02',
    type: 'cameraPresenter',
    description: 'this is has no reason to be this long, I am am just trying things out'
  },
  layer: {
    animation: {
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1,
        top: 114.28571428571429,
        left: 114.28571428571429,
        width: 835.7142857142857,
        height: 415.7142857142857
      },
      exit: {
        opacity: 0
      },
      transition: {
        duration: 0
      }
    },
    style: {
      zIndex: 1,
      position: 'absolute',
      top: 114.28571428571429,
      left: 114.28571428571429,
      mediaStyle: {
        maxWidth: '100%',
        display: 'block',
        margin: '0 auto',
        objectFit: 'cover',
        width: 835.7142857142857,
        height: 415.7142857142857
      },
      margin: 0,
      borderRadius: 4,
      width: 835.7142857142857,
      height: 415.7142857142857,
      bannerStyles: {
        top: 490,
        zIndex: 1,
        overflow: 'hidden',
        position: 'absolute',
        left: 114.28571428571429,
        maxWidth: 835.7142857142857
      },
      bannerAnimation: {
        initial: {
          opacity: 0
        },
        animate: {
          top: 450,
          opacity: 1,
          left: 114.28571428571429
        },
        exit: {
          opacity: 0
        },
        transition: {
          duration: 1
        }
      }
    }
  }
};